import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7390068e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_titles"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "_lc"
}, null, -1));
const _hoisted_3 = {
  class: "text_a"
};
const _hoisted_4 = {
  class: "right"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.message), 1), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default")])]);
    };
  }
});